import React, { useEffect, useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import TextInput from '@/components/common/TextInput'

const SpeakersSearch = ({ searchValue, setSearchValue }) => {
  const [value, setValue] = useState(searchValue)

  useEffect(() => {
    searchValue !== value && setValue(searchValue)
  }, [searchValue])

  return (
    <div className="relative mt-6 mb-6 md:bg-black md:mt-8">
      <TextInput
        className="leading-7 text-gray-200 border-b border-custom-gray-80 md:h-16 h-12 bg-black w-full md:px-6 px-4 font-normal placeholder:font-normal placeholder:text-custom-gray-80 md:placeholder:text-lg placeholder:text-sm focus:outline-none tracking-wide md:text-lg text-sm placeholder:drop-shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
        placeHolder="Search by Speaker Name, Topic, or Type"
        onChange={(e) => setValue(e.target.value)}
        value={value}
        onKeyPress={(e) => e.key === 'Enter' && setSearchValue(value)}
      />
      <FiSearch
        className="absolute w-6 h-8 transform -translate-y-1/2 cursor-pointer pointer top-1/2 right-3 bg-gray opacity-60"
        onClick={() => setSearchValue(value)}
        aria-label="search"
      />
    </div>
  )
}

export default React.memo(SpeakersSearch)
